import { render, staticRenderFns } from "./Consignation.vue?vue&type=template&id=86b683f4&scoped=true&"
import script from "./Consignation.vue?vue&type=script&lang=js&"
export * from "./Consignation.vue?vue&type=script&lang=js&"
import style0 from "./Consignation.vue?vue&type=style&index=0&id=86b683f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b683f4",
  null
  
)

export default component.exports